(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["skin-hair-calendar-waitlist"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializeCountdowns = (root = document) => {
      root.querySelectorAll('[data-calendar-countdown]').forEach((countdown) => {
        if (countdown.dataset.countdownInitialized === 'true') return;

        const launchTime = new Date(countdown.dataset.launchAt).getTime();
        const units = countdown.querySelector('[data-countdown-units]');
        const completeMessage = countdown.querySelector('[data-countdown-complete]');
        const fields = {
          days: countdown.querySelector('[data-countdown-days]'),
          hours: countdown.querySelector('[data-countdown-hours]'),
          minutes: countdown.querySelector('[data-countdown-minutes]'),
          seconds: countdown.querySelector('[data-countdown-seconds]')
        };

        if (Number.isNaN(launchTime)) {
          countdown.hidden = true;
          return;
        }

        countdown.dataset.countdownInitialized = 'true';
        let countdownTimer;

        const updateCountdown = () => {
          const remaining = launchTime - Date.now();

          if (remaining <= 0) {
            units.hidden = true;
            completeMessage.hidden = false;
            window.clearInterval(countdownTimer);
            return;
          }

          fields.days.textContent = Math.floor(remaining / 86400000);
          fields.hours.textContent = String(Math.floor((remaining % 86400000) / 3600000)).padStart(2, '0');
          fields.minutes.textContent = String(Math.floor((remaining % 3600000) / 60000)).padStart(2, '0');
          fields.seconds.textContent = String(Math.floor((remaining % 60000) / 1000)).padStart(2, '0');
        };

        updateCountdown();
        if (!units.hidden) {
          countdownTimer = window.setInterval(updateCountdown, 1000);
        }
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initializeCountdowns());
    } else {
      initializeCountdowns();
    }

    document.addEventListener('shopify:section:load', (event) => initializeCountdowns(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
